"use strict";
// Stremio Plus: client for the stremio-plus Supabase edge function.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.STREMIO_PLUS_API = exports.ERROR_WRONG_RECOVERY = exports.ERROR_WRONG_PIN = exports.ERROR_PIN_LOCKED = exports.PlusApiError = void 0;
var PlusApiError = /** @class */ (function (_super) {
    __extends(PlusApiError, _super);
    function PlusApiError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        return _this;
    }
    return PlusApiError;
}(Error));
exports.PlusApiError = PlusApiError;
exports.ERROR_PIN_LOCKED = 7;
exports.ERROR_WRONG_PIN = 9;
exports.ERROR_WRONG_RECOVERY = 12;
exports.STREMIO_PLUS_API = process.env.STREMIO_PLUS_API;
var call = function (method_1, authKey_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([method_1, authKey_1], args_1, true), Promise, function (method, authKey, body) {
        var response, json;
        if (body === void 0) { body = {}; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("".concat(exports.STREMIO_PLUS_API, "/").concat(method), {
                        method: 'POST',
                        headers: { 'content-type': 'application/json' },
                        body: JSON.stringify(__assign(__assign({}, body), { authKey: authKey })),
                    })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    if (json.error)
                        throw new PlusApiError(json.error.code, json.error.message);
                    return [2 /*return*/, json.result];
            }
        });
    });
};
var api = {
    listProfiles: function (authKey) { return call('profileList', authKey); },
    unlock: function (authKey, profileId, pin) { return call('profileUnlock', authKey, { profileId: profileId, pin: pin }); },
    saveProfile: function (authKey, profileToken, profile) { return call('profileSave', authKey, { profileToken: profileToken, profile: profile }); },
    deleteProfile: function (authKey, profileToken, profileId) { return call('profileDelete', authKey, { profileToken: profileToken, profileId: profileId }); },
    setPin: function (authKey, profileToken, profileId, pin, currentPin) {
        return call('profileSetPin', authKey, { profileToken: profileToken, profileId: profileId, pin: pin, currentPin: currentPin });
    },
    getRecoveryPhrase: function (authKey, profileToken, profileId, pin) {
        return call('profileRecoveryPhrase', authKey, { profileToken: profileToken, profileId: profileId, pin: pin });
    },
    regenerateRecoveryPhrase: function (authKey, profileToken, profileId, pin) {
        return call('profileRegenerateRecoveryPhrase', authKey, { profileToken: profileToken, profileId: profileId, pin: pin });
    },
    // Owner only: replaces the whole account addon collection.
    setAddons: function (authKey, profileToken, addons) { return call('addonCollectionSet', authKey, { profileToken: profileToken, addons: addons }); },
    recoverPin: function (authKey, profileId, recoveryPhrase, pin) {
        return call('profileRecoverPin', authKey, { profileId: profileId, recoveryPhrase: recoveryPhrase, pin: pin });
    },
};
exports.default = api;
